import Phaser from 'phaser'
 
var KeyEsc
var KeyEnt
var KeyNew
var KeyM
let cursor
var zone
var zone_2
var container_1
var container_2
var container_3
var container_4
var container_5
var container_6
var answerArray
var length
var container_top
var answerArr

export default class DragDropZone extends Phaser.Scene {
    private question!: string
    private answer1!: string
    private answer2!: string
    private answer3!: string
    private answer4!: string
    private answer5!: string
    private answer6!: string
    private rightAnswer!: []
    private caller!: string
    private bool!: boolean
    private tension!: Phaser.Sound.BaseSound
    private backgroundmusic!: Phaser.Sound.BaseSound
    private explanation!: string

    constructor() {
        super('dragDropZone')
    }

    init(data) {
        this.question = data.question
        this.answer1 = data.answer1
        this.answer2 = data.answer2
        this.answer3 = data.answer3
        this.answer4 = data.answer4
        this.answer5 = data.answer5
        this.answer6 = data.answer6
        this.rightAnswer = data.rightAnswer
        this.caller = data.caller
        this.explanation = data.explanation
    }

    create() {
        this.scene.stop('hints')
        this.scene.stop('equipment')

        var flag = sessionStorage.getItem('flag')
        if (flag == "true") {
            this.backgroundmusic = this.sound.get('backgroundmusic')
            this.sound.stopAll()
            this.tension = this.sound.add('question', {volume: 0.1, loop: true})
            this.tension.play()
        }

        this.add.image(512, 250, 'background')

        const questionRectWidth = 824;
        const questionRectHeight = 100;
        const questionRectX = (1024 - questionRectWidth) / 2;
        const questionRectY = 55;
       
        const questionRect = this.add.graphics();
        questionRect.fillStyle(0xFFFAFA, 1);
        questionRect.fillRoundedRect(questionRectX, questionRectY, questionRectWidth, questionRectHeight, 25);
       
        this.add.text(questionRectX + 10, questionRectY + 30, this.question, {
            fontSize: '18px',
            color: '#000000',
            align: 'center',
            wordWrap: {
                width: questionRectWidth - 20,
            }
        });

        const answer1RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('1')
        const answer2RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('2')
        const answer3RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('3')
        const answer4RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('4')
        const answer5RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('5')
        const answer6RectR = this.add.rectangle(0, 0, 400, 60, 0xADD8E6).setName('6')

        const answer1Text = this.add.text(-150, -20, this.answer1, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_1 = this.add.container(525, 205, [answer1RectR, answer1Text]).setSize(400, 70).setInteractive().setName('1'); this.input.setDraggable(container_1)
        const answer2Text = this.add.text(-150, -20, this.answer2, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_2 = this.add.container(525, 205, [answer2RectR, answer2Text]).setSize(400, 70).setInteractive().setName('2'); this.input.setDraggable(container_2)
        const answer3Text = this.add.text(-150, -20, this.answer3, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_3 = this.add.container(525, 205, [answer3RectR, answer3Text]).setSize(400, 70).setInteractive().setName('3'); this.input.setDraggable(container_3)
        const answer4Text = this.add.text(-150, -20, this.answer4, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_4 = this.add.container(525, 205, [answer4RectR, answer4Text]).setSize(400, 70).setInteractive().setName('4'); this.input.setDraggable(container_4)
        const answer5Text = this.add.text(-150, -20, this.answer5, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_5 = this.add.container(525, 205, [answer5RectR, answer5Text]).setSize(400, 70).setInteractive().setName('5'); this.input.setDraggable(container_5)
        const answer6Text = this.add.text(-150, -20, this.answer6, { fontSize: '14px', color: '0xffff00', align: 'left', wordWrap: { width: 350 } })
        container_6 = this.add.container(525, 205, [answer6RectR, answer6Text]).setSize(400, 70).setInteractive().setName('6'); this.input.setDraggable(container_6)

        const dropZoneWidth = 400;
        const dropZoneHeight = 290;
        const dropZoneY = 240;
       
        const rightZone = this.add.graphics();
        rightZone.fillStyle(0x00ff00, 0.5);
        rightZone.fillRoundedRect(75, dropZoneY, dropZoneWidth, dropZoneHeight, 20);
        zone = this.add.zone(275, dropZoneY + dropZoneHeight / 2, dropZoneWidth, dropZoneHeight).setRectangleDropZone(dropZoneWidth, dropZoneHeight);
        zone.setName('right');
        zone.setData({ cards: 0 });

        const wrongZone = this.add.graphics();
        wrongZone.fillStyle(0xff0000, 0.5);
        wrongZone.fillRoundedRect(525, dropZoneY, dropZoneWidth, dropZoneHeight, 20);
        zone_2 = this.add.zone(725, dropZoneY + dropZoneHeight / 2, dropZoneWidth, dropZoneHeight).setRectangleDropZone(dropZoneWidth, dropZoneHeight);
        zone_2.setName('wrong');
        zone_2.setData({ cards: 0 });

        container_top = 5;
        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Container) => {
            this.children.bringToTop(gameObject);
        });
        this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Container, dragX, dragY) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on('drop', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Container, dropZone: Phaser.GameObjects.Rectangle) => {
            gameObject.x = dropZone.x;
            gameObject.y = (dropZone.y - 115) + (dropZone.data.values.cards * 70);
            dropZone.data.values.cards++;
            gameObject.disableInteractive();
            container_top--;
        });
        this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Container, dropped) => {
            if (!dropped) {
                if (gameObject?.input) {
                    gameObject.x = gameObject.input.dragStartX;
                    gameObject.y = gameObject.input.dragStartY;
                }
            }
        });

        var notice_count = sessionStorage.getItem('notice_count_1');
        if (notice_count == 'right') {
            this.scene.launch('notice', {
                text: 'Du kannst die Kärtchen auch mit den Pfeiltasten deiner Tastatur nach links oder rechts bewegen.',
                caller: 'DragDropZone'
            })
        }
        sessionStorage.setItem('notice_count_1', "false");

        answerArr = [container_1, container_2, container_3, container_4, container_5, container_6]

        const sceneHeight = this.scale.height;
        const margin = 10;
        length = this.rightAnswer.length
        answerArray = this.rightAnswer
        const clickButton = this.add.text(850, 0, `Überprüfen`, {
            color: 'black',
            fontSize: '25px',
            stroke: 'black',
            strokeThickness: 2,
            backgroundColor: 'lightgreen'
        })
            .setInteractive()

        const buttonHeight = clickButton.height;
        const buttonY = sceneHeight - buttonHeight - margin;
        clickButton.setY(buttonY);

        clickButton.on('pointerdown', () => {
            this.resolve();
        })

        const clickButton_2 = this.add.text(880 - clickButton.width - 10, buttonY, `Zurück`, {
            color: 'black',
            fontSize: '25px',
            stroke: 'black',
            strokeThickness: 2,
            backgroundColor: 'yellow'
        })
        .setInteractive()

        clickButton_2.on('pointerdown', () => {
            if (container_top < 5) {
                container_top++;
                const container = answerArr[container_top];
                if (container.x === zone.x) {
                    zone.data.values.cards--;
                } else if (container.x === zone_2.x) {
                    zone_2.data.values.cards--;
                }
                container.setInteractive();
                container.x = 525;
                container.y = 205;
                this.children.bringToTop(container);
            }
        });

        // inserting information icon with explanation about how to handle with questions 
        const iconX = this.scale.width - 95;  
        const iconY = 59;                     
        const infoIcon = this.add.image(iconX, iconY, 'info')
            .setInteractive()
            //.setAlpha(0.9)
            .setScale(0.12, 0.12)             
            .setDepth(1000);

        // text and position of information box
        const infoMessage = 'Um die Kärtchen in die richtigen Felder (richtig oder falsch) zuzuordnen, kannst du sie entweder mit der Maus in das passende Feld ziehen oder mit den Pfeiltasten nach links bzw. rechts verschieben.';
        const boxWidth = 290;
        const boxX = iconX - boxWidth - 28;  
        const boxY = iconY + 8;             

        const textMetrics = this.add.text(0, 0, infoMessage, {
            font: '15px Courier',
            wordWrap: { width: boxWidth - 28 }
        }).setVisible(false);

        const boxHeight = textMetrics.height + 24;

        // details of style of text
        const infoBoxBg = this.add.graphics().setDepth(999);
        infoBoxBg.fillStyle(0xffffff, 1);
        infoBoxBg.fillRoundedRect(boxX, boxY, boxWidth, boxHeight, 10);
        infoBoxBg.lineStyle(2, 0x444444, 1);
        infoBoxBg.strokeRoundedRect(boxX, boxY, boxWidth, boxHeight, 10);
        infoBoxBg.setVisible(false);

        const infoText = this.add.text(boxX + 14, boxY + 12, infoMessage, {
            font: '15px Courier',
            color: '#000000',
            wordWrap: { width: boxWidth - 28 },
            align: 'left'
        })
        .setVisible(false)
        .setDepth(1000);

        // acitvate hover effect
        infoIcon.on('pointerover', () => {
            infoBoxBg.setVisible(true);
            infoText.setVisible(true);
        });
        infoIcon.on('pointerout', () => {
            infoBoxBg.setVisible(false);
            infoText.setVisible(false);
        });


        this.events.on('resume', () => {
            this.scene.stop()
            this.scene.start('equipment')
            this.scene.start('mapButton')
            this.scene.start('musikButton')
            this.scene.resume(this.caller, {bool: this.bool, caller: 'dragDropZone'})
        })

        if(this.input?.keyboard){
            KeyEsc = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC)
            KeyEnt = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER)
            KeyNew = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.N)
            cursor = this.input.keyboard.createCursorKeys()
        }
    }

    resolve() {
        this.sound.remove(this.tension)
        var flag = sessionStorage.getItem('flag');
        if (flag == "true") {
            this.backgroundmusic.play()
        }

        var right = 0
        var wrong = 0
        var count = 0
        var arr = [container_1, container_2, container_3, container_4, container_5, container_6]
        for (var i = 0; i < arr.length; i++) {
            count = 0
            for (var j = 0; j < length; j++) {
                if (answerArray[j] == arr[i].name) {
                    if (arr[i].x >= zone.x && arr[i].x < zone_2.x && arr[i].y + 115 >= zone.y) {
                        right = right + 1
                        break
                    } else {
                        wrong = wrong + 1
                        break
                    }
                } else {
                    count = count + 1
                }
            }
            if (count == answerArray.length) {
                if (arr[i].x >= zone_2.x) {
                    right = right + 1
                } else {
                    wrong = wrong + 1
                }
            }
        }
        if (wrong == 0) {
            this.bool = true
            this.scene.launch('warning', {
                text: 'Das war richtig. Du kannst in den nächsten Raum vordringen.',
                caller: 'dragDropZone',
                answer: true,
            })
            //this.scene.pause()
            this.scene.stop()// damit die Drag-and-Drop-Frage aus Level 6 nicht in Level 7 erneut geladen wird
        } else {
            this.bool = false

            // SCORE erhöhen
            let currentScore: number = parseInt(sessionStorage.getItem('score') || '0', 10);
            currentScore += 10;
            sessionStorage.setItem('score', currentScore.toString());

            // Penalty-Animation mit Musik und Effekten
            this.showPenaltyAnimation();

            // Verzögerung, damit Animation sichtbar bleibt
            this.time.delayedCall(2000, () => {
                this.scene.launch('warning', {
                    text: '',
                    header: 'Das war leider falsch. \n Du musst das Level nochmal spielen.',
                    caller: 'dragDropZone',
                    answer: false,
                })
                this.scene.pause()
            })
        }
    }

    private showPenaltyAnimation() {
        this.cameras.main.shake(500, 0.02);

        const flashOverlay = this.add.rectangle(
            this.scale.width / 2,
            this.scale.height / 2,
            this.scale.width,
            this.scale.height,
            0xff0000,
            0.3
        );

        this.tweens.add({
            targets: flashOverlay,
            alpha: 0,
            duration: 300,
            onComplete: () => flashOverlay.destroy()
        });

        const penaltyText = this.add
            .text(this.scale.width / 2, this.scale.height / 2 - 150, '+10 sec', {
                fontSize: '64px',
                fontStyle: 'bold',
                color: '#ff0000',
                stroke: '#ffffff',
                strokeThickness: 4
            })
            .setOrigin(0.5)
            .setScale(0)
            .setRotation(Math.PI * 0.25);

        try {
            const particles = this.add.particles(this.scale.width / 2, this.scale.height / 2 - 150, 'particle', {
                speed: { min: 100, max: 200 },
                scale: { start: 0.3, end: 0 },
                tint: [0xff0000, 0xff4444, 0xff8888],
                lifespan: 800,
                quantity: 15
            });
            this.time.delayedCall(800, () => {
                particles.destroy();
            });
        } catch (error) {
            for (let i = 0; i < 10; i++) {
                const circle = this.add.circle(
                    this.scale.width / 2 + (Math.random() - 0.5) * 100,
                    this.scale.height / 2 - 150 + (Math.random() - 0.5) * 100,
                    Math.random() * 10 + 5,
                    0xff0000
                );
                this.tweens.add({
                    targets: circle,
                    alpha: 0,
                    scale: 0,
                    duration: 800,
                    delay: Math.random() * 200,
                    onComplete: () => circle.destroy()
                });
            }
        }

        const errorText = this.add
            .text(this.scale.width / 2, this.scale.height / 2 - 80, 'FEHLER!', {
                fontSize: '32px',
                fontStyle: 'bold',
                color: '#ff4444'
            })
            .setOrigin(0.5)
            .setAlpha(0);

        this.tweens.add({
            targets: penaltyText,
            scale: { from: 0, to: 1.2 },
            rotation: 0,
            duration: 400,
            ease: 'Back.easeOut',
            onComplete: () => {
                this.tweens.add({
                    targets: penaltyText,
                    scale: 1,
                    y: penaltyText.y - 80,
                    alpha: { from: 1, to: 0 },
                    duration: 2000,
                    ease: 'Cubic.easeOut',
                    onComplete: () => penaltyText.destroy()
                });
            }
        });

        this.tweens.add({
            targets: errorText,
            alpha: { from: 0, to: 1 },
            y: errorText.y + 10,
            duration: 300,
            delay: 200,
            ease: 'Power2.easeOut',
            onComplete: () => {
                this.tweens.add({
                    targets: errorText,
                    alpha: 0,
                    y: errorText.y - 50,
                    duration: 1800,
                    delay: 300,
                    onComplete: () => errorText.destroy()
                });
            }
        });

        var flag = sessionStorage.getItem('flag');
        if (flag == "true") {
            try {
                this.sound.play('wrongAnswer', { volume: 0.15 });
            } catch (error) {
                // Falls Sound nicht existiert, ignorieren
            }
        }
    }

    update() {
        if (container_top >= 0) {
            if (Phaser.Input.Keyboard.JustDown(cursor.left)) {
                const currentContainer = answerArr[container_top];
                currentContainer.x = zone.x;
                currentContainer.y = (zone.y - 115) + (zone.data.values.cards * 70);
                zone.data.values.cards++;
                this.children.bringToTop(currentContainer);
                container_top--;
            } else if (Phaser.Input.Keyboard.JustDown(cursor.right)) {
                const currentContainer = answerArr[container_top];
                currentContainer.x = zone_2.x;
                currentContainer.y = (zone_2.y - 115) + (zone_2.data.values.cards * 70);
                zone_2.data.values.cards++;
                this.children.bringToTop(currentContainer);
                container_top--;
            }
        } else if (Phaser.Input.Keyboard.JustDown(KeyEsc)) {
            this.scene.stop();
            this.scene.start('equipment');
            this.scene.start('mapButton');
            this.scene.start('musikButton');
            this.scene.resume(this.caller, { caller: 'dragDropZone' });
        } else if (Phaser.Input.Keyboard.JustDown(KeyEnt)) {
            this.resolve();
        } else if (Phaser.Input.Keyboard.JustDown(KeyNew)) {
            this.scene.restart();
        }
    }
}
